<template>
  <ul
    v-if="visible && items && items.length"
    class="tp-suggest"
  >
    <li
      v-for="(item, i) in items"
      :key="i"
      class="tp-suggest__item"
      @mousedown.prevent="$emit('select', item)"
    >
      {{ labelKey ? item[labelKey] : item }}
    </li>
  </ul>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SuggestionDropdown',
  props: {
    items: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
    labelKey: { type: String, default: '' },
  },
  emits: ['select'],
});
</script>

<style scoped>
.tp-suggest {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: var(--tm-radius-md, 14px);
  box-shadow: var(--tm-shadow-lg);
  animation: tp-suggest-in 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes tp-suggest-in {
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.tp-suggest__item {
  padding: 8px 12px;
  border-radius: var(--tm-radius-xs, 5px);
  font-size: 0.875rem;
  color: var(--tm-ink, var(--dark));
  cursor: pointer;
  transition: background 0.12s ease;
}

.tp-suggest__item:hover {
  background: var(--tm-surface-hover, rgba(22, 104, 227, 0.1));
}
</style>
